module.exports = __webpack_public_path__ + "static/img/release.303ea2e.png";


//////////////////
// WEBPACK FOOTER
// ./static/images/skillTutor/release.png
// module id = 24p7
// module chunks = 1